import React from 'react';

const HowTo = () => {
  return (
    <>
      <div className="text-center mb-12">
        <h2 id="how-it-works-title" className="text-3xl md:text-4xl font-bold tracking-tight text-[var(--color-text-primary)] mb-4">How It Works</h2>
        <p id="how-it-works-description" className="text-lg text-[var(--color-text-secondary)] max-w-2xl mx-auto">Our simple 4-step process to connect with your ideal customers.</p>
      </div>
      <div id="how-to-steps-container" className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div id="step-1" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-3xl">target</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">1. Choose Subreddit</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Enter the target community where your potential customers or collaborators are active.</p>
        </div>
        <div id="step-2" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-3xl">manage_search</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">2. Define Your Search</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Enter keywords to guide the AI toward the most relevant opportunities.</p>
        </div>
        <div id="step-3" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-3xl">format_list_numbered</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">3. Select Post Count</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Choose the number of recent posts to fetch for analysis.</p>
        </div>
        <div id="step-4" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-3xl">chat</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">4. Discover & Connect</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Discover posts highlighting unmet needs and opportunities - and connect with the right people.</p>
        </div>
      </div>
    </>
  );
};

export default HowTo;
